var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4987 53.2526C50.207 53.2109 49.832 53.2109 49.4987 53.2526C42.1654 53.0026 36.332 47.0026 36.332 39.6276C36.332 32.0859 42.4154 25.9609 49.9987 25.9609C57.5404 25.9609 63.6654 32.0859 63.6654 39.6276C63.6237 47.0026 57.832 53.0026 50.4987 53.2526Z",
    stroke: "#969696",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0827 80.75C70.666 87.5417 60.8327 91.6667 49.9994 91.6667C39.166 91.6667 29.3327 87.5417 21.916 80.75C22.3327 76.8333 24.8327 73 29.291 70C40.7077 62.4167 59.3743 62.4167 70.7077 70C75.166 73 77.666 76.8333 78.0827 80.75Z",
    stroke: "#969696",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9997 91.6693C73.0115 91.6693 91.6664 73.0145 91.6664 50.0026C91.6664 26.9907 73.0115 8.33594 49.9997 8.33594C26.9878 8.33594 8.33301 26.9907 8.33301 50.0026C8.33301 73.0145 26.9878 91.6693 49.9997 91.6693Z",
    stroke: "#969696",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.bab2be4f6ef813dd7cc98a26e98b685a.svg";
export { ForwardRef as ReactComponent };